<template>
    <div class=" uk-padding uk-background-muted" style="min-height: 85vh !important;">

        <h1  class="uk-heading-line uk-text-center specHeading" ><span>Church & Community Relations</span> </h1>
        <div class="uk-container ">
            <div class="uk-child-width-1-1@m" uk-grid>

                <div class="uk-panel"><br>
                    <img class="uk-align-left uk-margin-remove-adjacent" src="../assets/church.jpg"  alt="Example image">
                    <p class=" ">
                        Northern Caribbean University Church is a multi-cultural, multi-ethnic, and multi-national faith
                        community that serves the Northern Caribbean University family, the Greater Mandeville area,
                        and the constituency of the Jamaica Union of Seventh-day Adventists.
                    </p>
                    <p class="">
                        Our vision is to have every member of the body of Christ, living in readiness for the Kingdom of
                        God as we glorify God, and under the influence of the Holy Spirit, lead every convert to
                        experience a personal and transforming relationship with Christ, enabling the believer to
                        become a disciple in sharing the Everlasting Gospel with everyone.
                        Every week, we meet to celebrate Jesus through fellowship, worship, and service. There are
                        many opportunities to discover and utilize your spiritual gifts, talents and interests for the
                        expansion of the kingdom of God. We are a fellowship where all people can discover the joy of
                        growing in Jesus.
                    </p>
                </div>
            </div>
            <div class="uk-child-width-1-3@m" uk-grid>
                <div>
                    <dl class="uk-description-list uk-description-list-divider">
                        <dt class="uk-heading-small " style="font-size: 18px; color: teal; font-weight: bolder !important;">Prison Ministry</dt>
                        <dd class="uk-text-small">
                            Prison Ministry is conducted at the New Broughton Adult Rehabilitation Centre on
                            the first Sabbath of each month. Recently 25 reading glasses were issued and at
                            least once per quarter toiletries and other well needed items are provided for each
                            resident.
                            <br><br>
                            Communion is served on a quarterly basis and Bible study guides and other reading
                            material issued.
                        </dd>

                    </dl>
                </div>
                <div>
                    <dl class="uk-description-list uk-description-list-divider">
                        <dt class="uk-heading-small " style="font-size: 18px; color: teal; font-weight: bolder !important;">Lunch n Learn Series</dt>
                        <dd class="uk-text-small">
                            Lunch n Learn Series is held every Sabbath and is structured to cater to
                            both the physical and spiritual needs of those members who attend.
                            <br><br>
                            Hot meals are served and Bible study shared while interaction with
                            each other is facilitated.
                        </dd>

                    </dl>
                </div>
                <div>
                    <dl class="uk-description-list uk-description-list-divider">
                        <dt class="uk-heading-small " style="font-size: 18px; color: teal; font-weight: bolder !important;">Community Impact</dt>
                        <dd class="uk-text-small">
                            Our community is primarily the NCU campus where the church is
                            taken on the first Sabbath afternoon of each month to the
                            respective dorms, starting at Cedar Hall as is our regular
                            practice. This will resume as soon as the Covid19 pandemic
                            subsides.
                        </dd>

                    </dl>
                </div>
                <div>
                    <dl class="uk-description-list uk-description-list-divider">
                        <dt class="uk-heading-small " style="font-size: 18px; color: teal; font-weight: bolder !important;">Baptism</dt>
                        <dd class="uk-text-small">
                            Baptisms are scheduled for the
                            first and third Sabbaths of each
                            month. However, persons
                            wishing to be baptized outside of
                            this schedule is facilitated when
                            needed.
                            <br><br>
                            Since the start of 2020, we have
                            baptized approximately 14
                            individuals.
                        </dd>

                    </dl>
                </div>
                <div>
                    <dl class="uk-description-list uk-description-list-divider">
                        <dt class="uk-heading-small " style="font-size: 18px; color: teal; font-weight: bolder !important;">New Believers’ Webinar</dt>
                        <dd class="uk-text-small">
                            Baptisms are scheduled for the
                            first and third Sabbaths of each
                            month. However, persons
                            wishing to be baptized outside of
                            this schedule is facilitated when
                            needed.
                            <br><br>
                            Since the start of 2020, we have
                            baptized approximately 14
                            individuals.
                        </dd>

                    </dl>
                </div>
                <div>
                    <dl class="uk-description-list uk-description-list-divider">
                        <dt class="uk-heading-small " style="font-size: 18px; color: teal; font-weight: bolder !important;">Counseling </dt>
                        <dd class="uk-text-small">
                            The Prayer Ministry Team along
                            with several members, meet via
                            zoom to have remote Prayer
                            Sessions every Wednesday
                            morning commencing at 5:30am.
                            <br><br>
                            Prayer is also done individually
                            via telephone for those not able
                            to meet using the zoom platform.
                        </dd>

                    </dl>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ChurchAndCommunity"
    }
</script>

<style scoped>
img{
    max-height: 400px;
    max-width: 400px;
    width: auto;
    height: auto;
}
</style>